import $ from "jquery";
import { gsap } from "gsap";

const faq = {
  element: {
    tabLink: $(".faq_tabs--tab"),
    faqContent: $(".faq_tabs_tabpanel"),
  },
  method: {
    animateFaqContent: function () {
      faq.element.tabLink.on("click", function (e) {
        const currId = e.target.id;

        gsap.set(".faq_tabs_tabpanel", {
          x: 200,
          opacity: 0.5,
        });

        gsap.to(".faq_tabs_tabpanel", {
          x: 0,
          opacity: 1,
          duration: 0.5,
        });
        
        faq.element.faqContent.each(function () {
          if ($(this).data("id") === currId) {
            $(this).addClass("show");
          } else {
            $(this).removeClass("show");
          }
        });
      });
    },
    addMargin:function(tabItem){

     const variables = {
      marginTopDesk : $(tabItem).data('desktop-margin-top'),
      marginBottomDesk : $(tabItem).data('desktop-margin-bottom'),
      marginRightDesk : $(tabItem).data('desktop-margin-right'),
      marginLeftDesk : $(tabItem).data('desktop-margin-left'),

      marginTopMob : $(tabItem).data('mobile-margin-top'),
      marginBottomMob : $(tabItem).data('mobile-margin-bottom'),
      marginRightMob : $(tabItem).data('mobile-margin-right'),
      marginLeftMob : $(tabItem).data('mobile-margin-left'),


     };
    
     const {marginTopDesk,marginBottomDesk,marginRightDesk,marginLeftDesk} = variables;

     const {marginTopMob,marginBottomMob,marginRightMob,marginLeftMob} = variables;

          if($(window).width() > 768){
            $(tabItem).css({
              'margin-top': marginTopDesk,
              'margin-bottom': marginBottomDesk,
              'margin-right':marginRightDesk,
              'margin-left': marginLeftDesk
             });
          }else{
            $(tabItem).css({
              'margin-top': marginTopMob,
              'margin-bottom': marginBottomMob,
              'margin-right':marginRightMob,
              'margin-left': marginLeftMob
            });
            $(tabItem).find('ol').addClass('common-Abbrevation-scroll');
          }
    },
      tabClickHandler: function(){
             $('.cmp-tabs__tab').on('click', function(e) {
                let tabList = $(this).closest('.faq_tabs--list'); 

                if ($(window).width() <= 768) {
                  let tabListWidth = tabList.width(); 
                  let tabWidth = $(this).outerWidth();
                  let tabOffset = $(this).position().left; 
                  let currentScroll = tabList.scrollLeft();

                  let scrollLeftPos = currentScroll + tabOffset - (tabListWidth / 2) + (tabWidth / 2);
            
                  tabList.scrollLeft(scrollLeftPos);
                }
                
                let buttonText = $(this).text().replace(/\n/g, '').trim();
                let container=$(this).closest('.genericContainer');
                  let pageSection=$(this).closest('.slide__pane').find('.heading-4 ').text();
                  let planOption;
                  let productName;
                  let productCategory;
                  let flag = document.querySelector("input[name='pageType']") != null && document.querySelector("input[name='pageType']").value == 'Product' ? true : false;


                  if(flag && document.querySelector("input[name='productCategoryName']") != null && document.querySelector("input[name='productName']") != null){

                  productName=document.querySelector('#productName').value;



                  productCategory=document.querySelector('#productCategoryName').value;

                  }
                  if(pageSection.length==0){
                  pageSection=container.find('.chlititle h2').text();
                 }
                 if(pageSection.length==0){
                  pageSection=container.find('.faq_title').text().replace(/\n/g, '').trim();
                 }
                 if(pageSection.length==0)
                 {
                  pageSection=buttonText;
                 }
                 else{
                  planOption=pageSection;
                  pageSection=pageSection.concat('_').concat(buttonText);
                
                 }
                let obj = faq.method.dataLayerObj(buttonText,pageSection,planOption,productName,productCategory);

                createDataLayer('buttonClick',obj);
             });
        },
    dataLayerObj: function (e,pageSection,planOption,productName,productCategory) {
                        var obj = {
                            'articleName': "",
                            'blogCategory': "",
                            'blogPageCategory': "",
                            'buttonText': e ? e : "",
                            'pageSection' : pageSection,
                            'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
                            'planOption': document.querySelector("input[name='pageType']") ? document.querySelector("input[name='pageType']").value == 'Product' ? planOption : "" : "",
                            'productCategory': productCategory,
                            'productName': productName,
                            'question': "",
                            'source': "",
                            'searchTerm':"",
                            'videoTitle': "",
                            'bannerName': "",
                        };
                        return obj;
                    },
    addIcon : (ele)=>{
      const iconsDiv = $(ele).find('.tabs__tab-icon').find('svg');
      const tabBox = $(ele).find('.faq_tabs--tab');
      if($(iconsDiv).length > 0){
        $(tabBox).each((idx,tabs)=>{
          $(tabs).addClass('position-relative add-svg')
          $(tabs).append(iconsDiv[idx]);
        })
      }
    }
  },
};

$(() => {
  if ($(".faq").length > 0) {
    faq.method.animateFaqContent();
    $('.tab__section__wrapper').each((index,tabItem)=>{
      faq.method.addMargin(tabItem);
      faq.method.addIcon(tabItem);
    });
    faq.method.tabClickHandler();
  }

});